const translations = {
  en: {
    app: { name: 'Workstation', tagline: 'Workspace Management System' },
    common: {
      loading: 'Loading...',
      error: 'An error occurred',
      retry: 'Retry',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      search: 'Search',
      filter: 'Filter',
      clear: 'Clear',
      confirm: 'Confirm',
      close: 'Close',
      noData: 'No data found',
      back: 'Back',
      next: 'Next',
      prev: 'Previous',
      actions: 'Actions',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      all: 'All',
      yes: 'Yes',
      no: 'No',
      online: 'Online',
      offline: 'Offline',
      syncing: 'Syncing...',
      pending: 'Pending',
    },
    nav: {
      dashboard: 'Dashboard',
      customers: 'Customers',
      rooms: 'Spaces & Rooms',
      checkin: 'Check In',
      activeSessions: 'Active Sessions',
      cafe: 'Cafe POS',
      inventory: 'Inventory',
      expenses: 'Expenses',
      reports: 'Reports',
      auditLogs: 'Activity Log',
      cafeItems: 'Cafe Items',
    },
    auth: {
      signIn: 'Sign In',
      signOut: 'Sign Out',
      signUp: 'Create Account',
      email: 'Email Address',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      name: 'Full Name',
      phone: 'Phone Number',
      welcomeBack: 'Welcome Back',
      signInToAccount: 'Sign in to your Workstation account',
      createAccount: 'Create Account',
      joinStudySpace: 'Join Workstation and start your learning journey',
      quickLogin: 'Quick Login',
      loginAsAdmin: 'Login as Admin (Demo)',
      dontHaveAccount: "Don't have an account?",
      alreadyHaveAccount: 'Already have an account?',
      signingIn: 'Signing in...',
      creatingAccount: 'Creating account...',
      passwordStrength: 'Password strength',
      optional: 'optional',
      forgotPassword: 'Forgot password?',
    },
    dashboard: {
      todayRevenue: "Today's Revenue",
      activeSessions: 'Active Sessions',
      availableRooms: 'Available Rooms',
      occupancy: 'Occupancy',
      cafeSales: 'Cafe Sales',
      expenses: 'Expenses',
      netProfit: 'Net Profit',
      thisWeek: 'This Week',
      thisMonth: 'This Month',
      quickActions: 'Quick Actions',
      checkInCustomer: 'Check In Customer',
      openCafePOS: 'Open Cafe POS',
      addExpense: 'Add Expense',
      manageRooms: 'Manage Rooms',
      roomOccupancy: 'Room Occupancy',
      recentActivity: 'Recent Activity',
      viewAll: 'View All',
      vsLastWeek: 'vs last week',
      vsLastMonth: 'vs last month',
    },
    customers: {
      title: 'Customers',
      createCustomer: 'Create Customer',
      editCustomer: 'Edit Customer',
      name: 'Customer Name',
      email: 'Email',
      phone: 'Phone',
      status: 'Status',
      search: 'Search customers...',
      noCustomers: 'No customers found',
      subscriptions: 'Subscriptions',
      createSubscription: 'Create Subscription',
      sessionHistory: 'Session History',
    },
    rooms: {
      title: 'Spaces & Rooms',
      createRoom: 'Add Room',
      editRoom: 'Edit Room',
      name: 'Room Name',
      type: 'Room Type',
      capacity: 'Capacity',
      hourlyRate: 'Hourly Rate',
      description: 'Description',
      public: 'Public Area',
      private: 'Private Room',
      silent: 'Silent Zone',
      status: 'Status',
      search: 'Search rooms...',
      noRooms: 'No rooms found',
      deactivateRoom: 'Deactivate Room',
      activateRoom: 'Activate Room',
      deactivateWarning: 'This room has active sessions. Are you sure?',
      occupancy: 'Occupancy',
      available: 'Available',
      unavailable: 'Unavailable',
    },
    checkin: {
      title: 'Check In Customer',
      selectCustomer: 'Select Customer',
      searchCustomer: 'Search by name, phone or email...',
      selectRoom: 'Select Room',
      notes: 'Notes (optional)',
      checkIn: 'Check In',
      checkingIn: 'Checking in...',
      success: 'Customer checked in successfully',
      noRoomsAvailable: 'No rooms available',
    },
    sessions: {
      title: 'Active Sessions',
      customer: 'Customer',
      room: 'Room',
      checkIn: 'Check In',
      checkOut: 'Check Out',
      duration: 'Duration',
      amount: 'Amount',
      status: 'Status',
      active: 'Active',
      completed: 'Completed',
      checkOutAndCollect: 'Check Out & Collect Payment',
      sessionHistory: 'Session History',
      totalSessions: 'Total Sessions',
      totalTime: 'Total Time',
      totalSpent: 'Total Spent',
      completedSessions: 'Completed',
      noActiveSessions: 'No active sessions',
      paymentSummary: 'Payment Summary',
      cancel: 'Cancel',
      cancelWarning: 'This session will be cancelled with no charge.',
      hours: 'hours',
      minutes: 'min',
    },
    cafe: {
      title: 'Cafe POS',
      items: 'Items',
      search: 'Search items...',
      category: 'Category',
      allCategories: 'All',
      beverages: 'Beverages',
      snacks: 'Snacks',
      meals: 'Meals',
      other: 'Other',
      cart: 'Cart',
      emptyCart: 'Cart is empty',
      total: 'Total',
      confirmSale: 'Confirm Sale',
      saleSuccess: 'Sale completed successfully',
      outOfStock: 'Out of stock',
      lowStock: 'Low stock',
      quantity: 'Qty',
      price: 'Price',
      addToCart: 'Add to cart',
      processing: 'Processing...',
      manageItems: 'Manage Menu',
      addItem: 'Add Item',
      itemCreated: 'Item created successfully',
    },
    inventory: {
      title: 'Inventory',
      search: 'Search items...',
      lowStockOnly: 'Low stock only',
      stockLevel: 'Stock Level',
      restock: 'Restock',
      restockTitle: 'Restock Item',
      quantity: 'Quantity to add',
      success: 'Stock updated successfully',
      noItems: 'No items found',
      item: 'Item',
      category: 'Category',
      inStock: 'In Stock',
      lowStock: 'Low Stock',
      outOfStock: 'Out of Stock',
    },
    categories: {
      title: 'Manage Categories',
      subtitle: 'Add, edit, or remove cafe item categories',
      name: 'Display Name',
      value: 'Value',
      add: 'Add',
      update: 'Update',
      deleteConfirm: 'Delete this category? Items using it will not be affected.',
      noData: 'No categories yet',
      created: 'Category created successfully',
      updated: 'Category updated successfully',
      deleted: 'Category deleted successfully',
    },
    expenses: {
      title: 'Expenses',
      createExpense: 'Add Expense',
      editExpense: 'Edit Expense',
      description: 'Description',
      amount: 'Amount',
      category: 'Category',
      date: 'Date',
      vendor: 'Vendor',
      search: 'Search expenses...',
      noExpenses: 'No expenses found',
      total: 'Total Expenses',
      inventory: 'Inventory',
      utilities: 'Utilities',
      maintenance: 'Maintenance',
      supplies: 'Supplies',
      salary: 'Salary',
      rent: 'Rent',
      other: 'Other',
    },
    reports: {
      title: 'Financial Reports',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      sessionIncome: 'Session Income',
      cafeIncome: 'Cafe Income',
      totalIncome: 'Total Income',
      totalExpenses: 'Total Expenses',
      netProfit: 'Net Profit',
      summary: 'Summary',
      breakdown: 'Breakdown',
      byRoomType: 'By Room Type',
      byCategory: 'By Category',
      byExpenseType: 'By Expense Type',
      noData: 'No data for this period',
      currency: 'EGP',
    },
    audit: {
      title: 'Activity Log',
      search: 'Search logs...',
      action: 'Action',
      user: 'User',
      entity: 'Entity',
      date: 'Date',
      description: 'Description',
      stats: 'Statistics',
      totalLogs: 'Total Logs',
      last24h: 'Last 24 Hours',
      mostCommon: 'Most Common Action',
      noLogs: 'No audit logs found',
    },
    errors: {
      notFound: 'Page not found',
      accessDenied: 'Access Denied',
      noPermission: "You don't have permission to access this page.",
      sessionExpired: 'Your session has expired. Please log in again.',
      networkError: 'Network error. Please check your connection.',
      serverError: 'Server error. Please try again later.',
      goToDashboard: 'Go to Dashboard',
    },
    operator: 'Operator',
    logout: 'Logout',
    language: 'العربية',
    currency: 'E£',
    currencyCode: 'EGP',
  },

  ar: {
    app: { name: 'وركستيشن', tagline: 'نظام إدارة مساحات العمل' },
    common: {
      loading: 'جاري التحميل...',
      error: 'حدث خطأ',
      retry: 'إعادة المحاولة',
      save: 'حفظ',
      cancel: 'إلغاء',
      delete: 'حذف',
      edit: 'تعديل',
      create: 'إنشاء',
      search: 'بحث',
      filter: 'تصفية',
      clear: 'مسح',
      confirm: 'تأكيد',
      close: 'إغلاق',
      noData: 'لا توجد بيانات',
      back: 'رجوع',
      next: 'التالي',
      prev: 'السابق',
      actions: 'إجراءات',
      status: 'الحالة',
      active: 'نشط',
      inactive: 'غير نشط',
      all: 'الكل',
      yes: 'نعم',
      no: 'لا',
      online: 'متصل',
      offline: 'غير متصل',
      syncing: 'مزامنة...',
      pending: 'معلق',
    },
    nav: {
      dashboard: 'لوحة التحكم',
      customers: 'العملاء',
      rooms: 'المساحات والغرف',
      checkin: 'تسجيل دخول',
      activeSessions: 'الجلسات النشطة',
      cafe: 'الكافيه',
      inventory: 'المخزون',
      expenses: 'المصروفات',
      reports: 'التقارير',
      auditLogs: 'سجل العمليات',
      cafeItems: 'إدارة الكافيه',
    },
    auth: {
      signIn: 'تسجيل الدخول',
      signOut: 'تسجيل الخروج',
      signUp: 'إنشاء حساب',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      confirmPassword: 'تأكيد كلمة المرور',
      name: 'الاسم الكامل',
      phone: 'رقم الهاتف',
      welcomeBack: 'مرحباً بعودتك',
      signInToAccount: 'سجل الدخول إلى حسابك في وركستيشن',
      createAccount: 'إنشاء حساب جديد',
      joinStudySpace: 'انضم إلى وركستيشن وابدأ رحلتك',
      quickLogin: 'تسجيل دخول سريع',
      loginAsAdmin: 'تسجيل الدخول كمسؤول (تجريبي)',
      dontHaveAccount: 'ليس لديك حساب؟',
      alreadyHaveAccount: 'لديك حساب بالفعل؟',
      signingIn: 'جاري تسجيل الدخول...',
      creatingAccount: 'جاري إنشاء الحساب...',
      passwordStrength: 'قوة كلمة المرور',
      optional: 'اختياري',
      forgotPassword: 'نسيت كلمة المرور؟',
    },
    dashboard: {
      todayRevenue: 'إيرادات اليوم',
      activeSessions: 'الجلسات النشطة',
      availableRooms: 'المساحات المتاحة',
      occupancy: 'الإشغال',
      cafeSales: 'مبيعات الكافيه',
      expenses: 'المصروفات',
      netProfit: 'صافي الربح',
      thisWeek: 'هذا الأسبوع',
      thisMonth: 'هذا الشهر',
      quickActions: 'إجراءات سريعة',
      checkInCustomer: 'تسجيل دخول عميل',
      openCafePOS: 'فتح الكافيه',
      addExpense: 'إضافة مصروف',
      manageRooms: 'إدارة المساحات',
      roomOccupancy: 'إشغال المساحات',
      recentActivity: 'آخر النشاطات',
      viewAll: 'عرض الكل',
      vsLastWeek: 'مقارنة بالأسبوع الماضي',
      vsLastMonth: 'مقارنة بالشهر الماضي',
    },
    customers: {
      title: 'العملاء',
      createCustomer: 'إضافة عميل',
      editCustomer: 'تعديل عميل',
      name: 'اسم العميل',
      email: 'البريد الإلكتروني',
      phone: 'رقم الهاتف',
      status: 'الحالة',
      search: 'بحث عن عميل...',
      noCustomers: 'لا يوجد عملاء',
      subscriptions: 'الاشتراكات',
      createSubscription: 'إنشاء اشتراك',
      sessionHistory: 'سجل الجلسات',
    },
    rooms: {
      title: 'المساحات والغرف',
      createRoom: 'إضافة مساحة',
      editRoom: 'تعديل مساحة',
      name: 'اسم المساحة',
      type: 'النوع',
      capacity: 'السعة',
      hourlyRate: 'السعر بالساعة',
      description: 'الوصف',
      public: 'مساحة مشتركة',
      private: 'غرفة خاصة',
      silent: 'منطقة هادئة',
      status: 'الحالة',
      search: 'بحث عن مساحة...',
      noRooms: 'لا توجد مساحات',
      deactivateRoom: 'تعطيل المساحة',
      activateRoom: 'تفعيل المساحة',
      deactivateWarning: 'تحتوي هذه المساحة على جلسات نشطة. هل أنت متأكد؟',
      occupancy: 'الإشغال',
      available: 'متاح',
      unavailable: 'غير متاح',
    },
    checkin: {
      title: 'تسجيل دخول عميل',
      selectCustomer: 'اختر العميل',
      searchCustomer: 'ابحث بالاسم أو الهاتف أو البريد...',
      selectRoom: 'اختر المساحة',
      notes: 'ملاحظات (اختياري)',
      checkIn: 'تسجيل دخول',
      checkingIn: 'جاري التسجيل...',
      success: 'تم تسجيل دخول العميل بنجاح',
      noRoomsAvailable: 'لا توجد مساحات متاحة',
    },
    sessions: {
      title: 'الجلسات النشطة',
      customer: 'العميل',
      room: 'المساحة',
      checkIn: 'تسجيل دخول',
      checkOut: 'تسجيل خروج',
      duration: 'المدة',
      amount: 'المبلغ',
      status: 'الحالة',
      active: 'نشطة',
      completed: 'مكتملة',
      checkOutAndCollect: 'تسجيل خروج وتحصيل',
      sessionHistory: 'سجل الجلسات',
      totalSessions: 'إجمالي الجلسات',
      totalTime: 'إجمالي الوقت',
      totalSpent: 'إجمالي الإنفاق',
      completedSessions: 'المكتملة',
      noActiveSessions: 'لا توجد جلسات نشطة',
      paymentSummary: 'ملخص الدفع',
      cancel: 'إلغاء',
      cancelWarning: 'سيتم إلغاء هذه الجلسة بدون أي رسوم.',
      hours: 'ساعات',
      minutes: 'دقيقة',
    },
    cafe: {
      title: 'الكافيه',
      items: 'المنتجات',
      search: 'بحث عن منتج...',
      category: 'التصنيف',
      allCategories: 'الكل',
      beverages: 'مشروبات',
      snacks: 'وجبات خفيفة',
      meals: 'وجبات',
      other: 'أخرى',
      cart: 'سلة المشتريات',
      emptyCart: 'السلة فارغة',
      total: 'الإجمالي',
      confirmSale: 'تأكيد البيع',
      saleSuccess: 'تمت عملية البيع بنجاح',
      outOfStock: 'غير متوفر',
      lowStock: 'مخزون منخفض',
      quantity: 'الكمية',
      price: 'السعر',
      addToCart: 'أضف للسلة',
      processing: 'جاري المعالجة...',
      manageItems: 'إدارة القائمة',
      addItem: 'إضافة صنف',
      itemCreated: 'تم إضافة الصنف بنجاح',
    },
    inventory: {
      title: 'المخزون',
      search: 'بحث في المخزون...',
      lowStockOnly: 'المخزون المنخفض فقط',
      stockLevel: 'مستوى المخزون',
      restock: 'إعادة تزويد',
      restockTitle: 'إعادة تزويد المخزون',
      quantity: 'الكمية المضافة',
      success: 'تم تحديث المخزون بنجاح',
      noItems: 'لا توجد منتجات',
      item: 'المنتج',
      category: 'التصنيف',
      inStock: 'متوفر',
      lowStock: 'مخزون منخفض',
      outOfStock: 'غير متوفر',
    },
    categories: {
      title: 'إدارة التصنيفات',
      subtitle: 'إضافة وتعديل وحذف تصنيفات عناصر الكافيه',
      name: 'الاسم',
      value: 'القيمة',
      add: 'إضافة',
      update: 'تحديث',
      deleteConfirm: 'حذف هذا التصنيف؟ العناصر المستخدمة له لن تتأثر.',
      noData: 'لا توجد تصنيفات بعد',
      created: 'تم إنشاء التصنيف بنجاح',
      updated: 'تم تحديث التصنيف بنجاح',
      deleted: 'تم حذف التصنيف بنجاح',
    },
    expenses: {
      title: 'المصروفات',
      createExpense: 'إضافة مصروف',
      editExpense: 'تعديل مصروف',
      description: 'الوصف',
      amount: 'المبلغ',
      category: 'التصنيف',
      date: 'التاريخ',
      vendor: 'المورد',
      search: 'بحث في المصروفات...',
      noExpenses: 'لا توجد مصروفات',
      total: 'إجمالي المصروفات',
      inventory: 'مخزون',
      utilities: 'مرافق',
      maintenance: 'صيانة',
      supplies: 'مستلزمات',
      salary: 'رواتب',
      rent: 'إيجار',
      other: 'أخرى',
    },
    reports: {
      title: 'التقارير المالية',
      daily: 'يومي',
      weekly: 'أسبوعي',
      monthly: 'شهري',
      sessionIncome: 'إيرادات الجلسات',
      cafeIncome: 'إيرادات الكافيه',
      totalIncome: 'إجمالي الإيرادات',
      totalExpenses: 'إجمالي المصروفات',
      netProfit: 'صافي الربح',
      summary: 'ملخص',
      breakdown: 'تفصيل',
      byRoomType: 'حسب نوع المساحة',
      byCategory: 'حسب التصنيف',
      byExpenseType: 'حسب نوع المصروف',
      noData: 'لا توجد بيانات لهذه الفترة',
      currency: 'ج.م',
    },
    audit: {
      title: 'سجل العمليات',
      search: 'بحث في السجل...',
      action: 'الإجراء',
      user: 'المستخدم',
      entity: 'الكيان',
      date: 'التاريخ',
      description: 'الوصف',
      stats: 'إحصائيات',
      totalLogs: 'إجمالي السجلات',
      last24h: 'آخر 24 ساعة',
      mostCommon: 'أكثر إجراء شائع',
      noLogs: 'لا توجد سجلات',
    },
    errors: {
      notFound: 'الصفحة غير موجودة',
      accessDenied: 'الوصول ممنوع',
      noPermission: 'ليس لديك صلاحية للوصول إلى هذه الصفحة.',
      sessionExpired: 'انتهت جلستك. الرجاء تسجيل الدخول مرة أخرى.',
      networkError: 'خطأ في الشبكة. الرجاء التحقق من الاتصال.',
      serverError: 'خطأ في الخادم. الرجاء المحاولة لاحقاً.',
      goToDashboard: 'الذهاب إلى لوحة التحكم',
    },
    operator: 'مشغل',
    logout: 'تسجيل الخروج',
    language: 'English',
    currency: 'ج.م',
    currencyCode: 'EGP',
  },
};

export default translations;
